import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom'

import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useTheme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import CustomButton from 'components/CustomButton'
import Popup from 'components/Popup'
import { useAuth } from 'hooks/useAuth'
import useQuery from 'hooks/useQuery'

export default function SignUp() {
  const { t } = useTranslation();
  const { push } = useHistory()
  const { spacing, palette } = useTheme()
  const [policyChecked, setPolicyChecked] = useState(false)
  const [optinChecked, setOptinChecked] = useState(true)
  const [error, setError] = useState(null)
  const { updateSubscription, temporaryAuth } = useAuth()
  const query = useQuery()

  if (!temporaryAuth) {
    push(process.env.REACT_APP_ACCOUNT_ID === '39' && process.env.REACT_APP_TOP_REDIRECT ? process.env.REACT_APP_TOP_REDIRECT : '/')
    return null
  }

  const user = temporaryAuth.user

  const handleClick = () => {
    updateSubscription({ optin_promotion_mail: optinChecked })
      .then(() => {
        const path = Boolean(query.continue) ? decodeURIComponent(query.continue) : '/'
        push(path)
      })
      .catch(setError)
  }

  return (
    <div
      style={{
        padding: spacing(6, 3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="body2">{t("Message.Signup.LoggedIn")}</Typography>
      <Typography variant="body2">{t("Message.Signup.ConfirmationOfUse")}</Typography>
      <Typography style={{ margin: spacing(6, 0), fontWeight: 'bold' }} variant="body1">
        {user.name}
      </Typography>
      <div style={{ maxWidth: 340, marginBottom: spacing(3) }}>
        <FormControlLabel
          style={{ marginBottom: spacing(3) }}
          control={
            <Checkbox
              color="primary"
              checked={policyChecked}
              onChange={e => setPolicyChecked(e.target.checked)}
            />
          }
          label={
            <Typography variant="caption">
              {t("Message.Signup.AgreeToProvide")}
            </Typography>
          }
        />
        <FormControlLabel
          style={{ marginBottom: spacing(3) }}
          control={
            <Checkbox
              color="primary"
              checked={optinChecked}
              onChange={e => setOptinChecked(e.target.checked)}
            />
          }
          label={
            <Typography variant="caption">
              {t("Message.Signup.ReceiveSpecialOffers")}
            </Typography>
          }
        />
        <Typography
          style={{ marginBottom: spacing(3), color: palette.link, cursor: 'pointer' }}
          align="center"
          variant="caption"
          component="p"
          onClick={() => window.open(process.env.REACT_APP_SPONCER_URL)}
        >
          {t("Message.Signup.ClickHere")}
        </Typography>
      </div>
      <CustomButton style={{ width: 210 }} onClick={handleClick} disabled={!policyChecked}>
        {t("Message.Signup.GetStarted")}
      </CustomButton>
      <Popup
        open={error !== null}
        onClose={() => setError(null)}
        title="エラーが発生しました"
        description="会員登録に失敗しました。"
        primaryText="OK"
        onClickPrimary={() => setError(null)}
      />
    </div>
  )
}
